import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { Observable } from 'rxjs/Observable';
import { environment } from '../../environments/environment';
import { CONSTANTS } from '../shared/constants';

@Injectable()
export class FaqsService {
  private faqsUrl: string;
  private topTenCategoryId: number;
  faqs: object [];
  allFaqs: object[];
  categories: object[];
  filteredFaqs: object[];
  
  constructor(private http: HttpClient) {
    this.faqsUrl = environment.wordpress.protocol + environment.wordpress.hostname + environment.wordpress.path;
    this.faqs = [];
    this.categories = [];
    this.filteredFaqs = [];
    this.getCategories();
   }

  getTopTenFaqs() {
    return this.http.get<object[]>(this.faqsUrl + CONSTANTS.faqs.faqsQueryParam + '?' + CONSTANTS.faqs.categoriesQueryParam  + '=' + this.topTenCategoryId).subscribe(
      (data) => {
        this.faqs = data;
      },
      (err: HttpErrorResponse) => {
        this.handleError(err);
    }); 
  }

  getAllFaqs() {
    return this.http.get<object[]>(this.faqsUrl + CONSTANTS.faqs.faqsQueryParam + '?' + CONSTANTS.faqs.perPageQueryParam + '=' + CONSTANTS.faqs.numberOfFaqs).subscribe(
      (data) => {
        this.allFaqs = data;
      },
      (err: HttpErrorResponse) => {
        this.handleError(err);
    }); 
  }

  getCategories() {
    return this.http.get<object[]>(this.faqsUrl + CONSTANTS.faqs.categoriesQueryParam + '?' + CONSTANTS.faqs.perPageQueryParam + '=' + CONSTANTS.faqs.numberOfCategories).subscribe(
      (data) => {
        this.categories = data;
        this.topTenCategoryId = data.filter((category) => { return category['slug'] === CONSTANTS.faqs.topTenSlug})[0]['id'];
        this.getTopTenFaqs();
        this.getAllFaqs();
      },
      (err: HttpErrorResponse) => {
        this.handleError(err);
    });
  }

  getFaqsByCategoryId(categoryId){
    return this.http.get<object[]>(this.faqsUrl + CONSTANTS.faqs.faqsQueryParam + '?' + CONSTANTS.faqs.categoriesQueryParam  + '=' + categoryId + '&' + CONSTANTS.faqs.perPageQueryParam + '=' + CONSTANTS.faqs.numberOfFaqs).subscribe(
      (data) => {
        this.faqs = data;
      },
      (err: HttpErrorResponse) => {
        this.handleError(err);
      });
  }

  private handleError(err:HttpErrorResponse){
    if (err.error instanceof Error) {
      // A client-side or network error occurred
      console.log('An error occurred:', err.error.message);
    } else {
      // The backend returned an unsuccessful response code
      console.log(`Backend returned code ${err.status}, body was: ${err.error}`);
    }
  }

}







// WEBPACK FOOTER //
// /codebuild/output/src4156872633/src/src/app/services/faqs.service.ts